import { useState, useCallback } from "react";
import { useAuth } from "./useAuth";

export function useQuery() {
  const { getToken } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const run = useCallback(
    async (queryFn, ...args) => {
      setLoading(true);
      setError(null);
      try {
        const token = await getToken();
        if (!token) return null;
        const result = await queryFn(token, ...args);
        return result;
      } catch (err) {
        setError(err.message || "Query failed");
        return null;
      } finally {
        setLoading(false);
      }
    },
    [getToken]
  );

  return { run, loading, error };
}

// Keep backward compat alias
export function useAdxQuery() {
  return useQuery();
}
